import React, { useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import CarRegistrationNumber from "../car-registration-number";
import LazyImage from "../../shared/lazy-image";
import { Text } from "@cars24/turbo-web/lib/text";

const EliteGetBestPrice = ({ section}) => {
    const { pageSection = {} } = section || {};
    const registrationInputRef = useRef(null);
    const { title = "Get the best price for your premium car", image} = pageSection || {};

    return (
        <div styleName={"styles.getBestPrice"}>
            <div styleName={"styles.eliteGetBestPriceBanner"}>
                <LazyImage src={image.url} alt={image.alternativeText} />
            </div>
            <div styleName="styles.getBestPriceWrapper">
                <div styleName={"styles.regNumber"}>
                    <Text
                        align="center"
                        as="h3"
                        fontWeight="semibold"
                        size="400"
                        transform="none"
                        color={"#101010"}
                    >
                        {title}
                    </Text>
                    <div styleName={"styles.elitePageReg"}>
                        <CarRegistrationNumber
                            registrationInputRef={registrationInputRef}
                            ctaText="Get car price"
                            isFormVisible={false}
                            isDlsCompliant
                            isElitePage
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

EliteGetBestPrice.propTypes = {
    section: PropTypes.object
};

export default EliteGetBestPrice;
